import React from "react";

import { InsideParallaxImage } from "components/Image/Index";

import { Parallax } from "react-scroll-parallax";

import * as fromProjects from "store/Projects";

import { a } from "@react-spring/web";
import { useIntersect } from "hooks/useIntersect";
import { useAnimateInTrail } from "hooks/useAnimateInTrail";
import { initialOffset } from "components/Animations/SpringProperties/SpringProperties";

interface IProps {
  animationReady: boolean;
  bodyContent: object;
}

export const OverlappingImageBoard: React.FC<IProps> = ({
  animationReady,
  ...props
}) => {
  const bodyContent: fromProjects.IContentOverlappingImageBoardSection =
    props.bodyContent as fromProjects.IContentOverlappingImageBoardSection;

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const [animateInTrail] = useAnimateInTrail(inView, bodyContent.images.length);

  const imageWrapperStyles = (index: number, rightOffset: string) => ({
    opacity: animateInTrail[index].active,
    transform: animateInTrail[index].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
    marginRight: rightOffset,
  });

  const getImages = () =>
    bodyContent.images.map((image, index) => {
      const totalImages = bodyContent.images.length; // this gives us the actual number of images, we will minus one to get an index value so the last image has an animation index of 0
      const imageAnimateIndex = totalImages - index - 1;

      return (
        <Parallax
          key={index}
          y={["0px", 30 + (totalImages - 1 - imageAnimateIndex) * 70 + "px"]}
          tagOuter="figure"
        >
          <a.div
            style={imageWrapperStyles(imageAnimateIndex, image.rightOffset)}
          >
            <InsideParallaxImage
              heightRatio={image.heightRatio}
              src={"/assets/images/work/" + image.url}
              alt={image.alt}
              placeholderBackgroundColor="transparent"
              animateImageIn={true}
              animationType={"fadeIn"}
            />
          </a.div>
        </Parallax>
      );
    });

  return (
    <div ref={inViewRef} className="overlappingImageBoardWrapper">
      {getImages()}
    </div>
  );
};
